import Vue from 'vue';
import Vuetify,{
    VMain,
    VApp,
    VCard,
    VCardText,
    VCardTitle,
    VExpansionPanel,
    VExpansionPanelContent,
    VBtn,
    VExpansionPanels,
    VRow,
    VCol,
    VContainer,
    VTextField,
    VSelect,
    VRadioGroup,
    VRadio
} from 'vuetify/lib';

import { Ripple } from 'vuetify/lib/directives'


Vue.use(Vuetify,{
    components : {
        VMain,
        VApp,
        VCard,
        VCardText,
        VCardTitle,
        VExpansionPanel,
        VExpansionPanelContent,
        VBtn,
        VExpansionPanels,
        VRow,
        VCol,
        VContainer,
        VTextField,
        VSelect,
        VRadioGroup,
        VRadio
    },
    directives : {
        Ripple
    }
});
const opts = {}
export default new Vuetify(opts);
